import * as type from '../constants/ActionTypes';

export default function payouts(
  state = {},
  action
) {
  switch (action.type) {
    case type.PAYOUT_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      });
    case type.PAYOUT_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        payoutsList: action.response,
      });
    case type.PAYOUT_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      });
    case type.PAYOUT_REQUEST_REQUEST:
      return Object.assign({}, state, {
        isProcessing: true
      });
    case type.PAYOUT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        isProcessing: false
      });
    case type.PAYOUT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        isProcessing: false
      });
    case type.PUT_PAYOUT_STATUS_REQUEST:
      return Object.assign({}, state, {
        isProcessing: true
      });
    case type.PUT_PAYOUT_STATUS_SUCCESS:
      return Object.assign({}, state, {
        isProcessing: false
      });
    case type.PUT_PAYOUT_STATUS_FAILURE:
      return Object.assign({}, state, {
        isProcessing: false
      });
    default:
      return state;
  }
}
